"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_i18next_1 = require("react-i18next");
var Tabs_1 = __importDefault(require("./Tabs"));
var BuyRent_1 = __importDefault(require("./Pages/BuyRent"));
var EssentialTipsTabs_1 = require("../../../constants/EssentialTipsTabs");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var BuyRentSpecialist_1 = __importDefault(require("./Pages/BuyRentSpecialist"));
var SellPage_1 = __importDefault(require("./Pages/SellPage"));
var SellSpecialist_1 = __importDefault(require("./Pages/SellSpecialist"));
var EssentialTipsLayout = function (_a) {
    var match = _a.match;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.essential_tips_layout },
        react_1.default.createElement("h1", null, t('ESSENTIAL_TIPS.ESSENTIAL') + ' ' + t('ESSENTIAL_TIPS.TIPS')),
        react_1.default.createElement(Tabs_1.default, { match: match }),
        react_1.default.createElement(react_router_dom_1.Switch, null,
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "" + (match.url + EssentialTipsTabs_1.EssentialTipsTabs[0].path), component: BuyRent_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "" + (match.url + EssentialTipsTabs_1.EssentialTipsTabs[1].path), component: BuyRentSpecialist_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "" + (match.url + EssentialTipsTabs_1.EssentialTipsTabs[2].path), component: SellPage_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "" + (match.url + EssentialTipsTabs_1.EssentialTipsTabs[3].path), component: SellSpecialist_1.default }))));
};
exports.default = EssentialTipsLayout;
